define( function() {
	"use strict";

	return ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/manipulation/var/rtagName.js
// module id = 63
// module chunks = 0